export default "__VITE_ASSET__3e876a47__"